var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu-item',{attrs:{"index":_vm.getIndex(),"path":_vm.getIndex(),"open-mode":_vm.menu.openMode}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.menu.title || '未命名菜单'))]),(!_vm.menu.isOnlyText)?_c('i',{class:`${_vm.menu.icon || 'fa fa-file-o'}`}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }